export default {
  path: '/billing',
  redirect: '/billing/summary',
  component: () => import('@/views/layout/Default'),
  children: [
    {
      path: 'summary',
      name: 'summary',
      component: () => import('@/views/billing/Summary'),
    },
    {
      path: 'data_transfer',
      name: 'dataTransfer',
      component: () => import('@/views/billing/DataTransfer'),
    },
    {
      path: 'cost_allocation_tags',
      name: 'costAllocationTags',
      component: () => import('@/views/billing/CostAllocationTags'),
    },
    {
      path: 'cost_pivot',
      name: 'costPivot',
      component: () => import('@/views/billing/CostPivot'),
    },
    {
      path: 'cost_pivot/:type',
      name: 'costPivotBq',
      component: () => import('@/views/billing/CostPivotBQ'),
    },
    {
      path: 'cost_trend',
      name: 'costTrend',
      component: () => import('@/views/billing/CostTrend'),
    },
    {
      path: 'cdn',
      name: 'cdn',
      component: () => import('@/views/billing/CDN'),
    },
    {
      path: 'usage_detail',
      name: 'usageDetail',
      component: () => import('@/views/billing/UsageDetail'),
    },
    {
      path: 'invoice',
      name: 'invoice',
      component: () => import('@/views/billing/Invoice'),
    },
    {
      path: 'alarm',
      name: 'alarm',
      component: () => import('@/views/billing/Alarm'),
    },
    {
      path: 'consolidated',
      name: 'consolidated',
      component: () => import('@/views/billing/Consolidated'),
    },
    {
      path: 'commitment_analysis',
      name: 'commitmentAnalysis',
      component: () => import('@/views/billing/CommitmentAnalysis'),
    },
    {
      path: 'cost_table',
      name: 'costTable',
      component: () => import('@/views/billing/CostTable'),
    },
  ],
}
